import { render, staticRenderFns } from "./Registerr.vue?vue&type=template&id=188b139a&scoped=true&"
import script from "./Registerr.vue?vue&type=script&lang=js&"
export * from "./Registerr.vue?vue&type=script&lang=js&"
import style0 from "./Registerr.vue?vue&type=style&index=0&id=188b139a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b139a",
  null
  
)

export default component.exports